<template>
  <div class='log-wrapper'>
    <div class='logo-card'>
      <div class='logo'>
        <img src="../../public/images/yunda logo 5.png" alt="logo" class='logo'>
      </div>
      <div class="logo-content">
      <el-tabs v-model="activeLog" class="tabs" :stretch="true">
        <el-tab-pane label="重设密码" name="reset" class='tab-pane'>
          <div class="input-group">
            <div class='title'>邮箱地址</div>
            <el-input place-holder="请输入登录用邮箱地址" v-model="email" required v-on:blur="validateEmail"></el-input>
            <div class='warning'>{{ warningEmail }}</div>
          </div>
          <div class="input-group">
            <div class='title'>确认邮箱地址</div>
            <el-input place-holder="请再次输入邮箱地址确认" v-model="reEmail" required v-on:blur="validateConfirm"></el-input>
            <div class='warning'>{{ warningConfirm }}</div>
          </div>
          <!-- <div class='buttons-set'>
            <button type="button" class="el-button el-button--info is-plain" style="width: 85px" @click="$emit('start-over')">Cancel</button>

          </div> -->
        </el-tab-pane>
      </el-tabs>
      </div>
      <div class='buttons-set'>
        <button class="el-button el-button--primary is-plain" @click="backToHome">返回登录界面</button>
        <vue-recaptcha ref="recaptcha"
          @verify="onVerifyReset"
          sitekey='6Ld_fmoUAAAAADe5Nj0zSlQm19cqGivLTvBInqIu'
          style="width: 100px">
          <button class="el-button el-button--primary">发送密码重设邮件</button>
        </vue-recaptcha>
      </div>
      <div class="loader" v-if="loading">
        <div style="margin: auto">
          <half-circle-spinner
            :animation-duration="4000"
            :size="50"
            color="#ff1d5e"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha'
import axios from 'axios'
import firebase from 'firebase/app'
import 'firebase/auth'
import { HalfCircleSpinner } from 'epic-spinners'

export default {
  name: 'ForgetPassword',
  data () {
    return {
      activeLog: 'reset',
      email: '',
      reEmail: '',
      warningEmail: '',
      warningConfirm: '',
      loading: false
    }
  },
  methods: {
    validateEmail: function () {
      var re = /\S+@\S+/
      var result = re.test(String(this.email).toLowerCase())
      if (!result) {
        this.warningEmail = '请输入有效的邮箱地址'
        this.$refs.recaptcha.reset()
        return
      }
      if (result) {
        this.warningEmail = ''
      }
    },
    validateConfirm: function () {
      if (this.reEmail === '') {
        this.warningConfirm = '请输入邮箱地址'
        this.$refs.recaptcha.reset()
        return
      }
      if (this.email !== this.reEmail) {
        this.warningConfirm = '两次输入的邮箱地址不一致'
        this.$refs.recaptcha.reset()
        return
      }
      this.warningConfirm = ''
    },
    toReset: function () {
      let that = this
      let auth = firebase.auth()
      auth.languageCode = 'zh'
      firebase.auth().sendPasswordResetEmail(that.email).then(() => {
        that.loading = false
        that.$message({
          message: `已经向 ${that.email} 发送了密码重设确认，请查看您的收件箱`,
          center: true,
          type: 'success'
        })
      }).catch(err => {
        that.loading = false
        that.$message({
          message: `无法向 ${that.email} 发送邮件, 请稍后重试`,
          center: true,
          type: 'error'
        })
        // console.log(err)
      })
    },
    onVerifyReset: function (response) {
      let that = this
      that.loading = true
      // console.log('Verify: ' + response)
      // Verify the token
      axios({
        method: 'post',
        url: 'https://yunda-us.firebaseapp.com/functions/recaptcha',
        data: {
          token: response
        }
      }).then(function (res) {
        // console.log(res.data)
        if (res.data === 'success') {
          // do the reset
          if (that.email !== that.reEmail) {
            that.$refs.recaptcha.reset()
            that.loading = false
            return
          }
          that.toReset()
        } else {
          that.$refs.recaptcha.reset()
          that.loading = false
          that.$message({
            message: `无法向 ${that.email} 发送邮件, 请稍后重试`,
            center: true,
            type: 'error'
          })
        }
      })
    },
    backToHome: function () {
      this.email = ''
      this.reEmail = ''
      this.warningEmail = ''
      this.warningConfirm = ''
      this.loading = false
      this.$router.push('/')
    }
  },
  components: {
    VueRecaptcha, HalfCircleSpinner
  }
}
</script>

<style>
input {
  margin-bottom: 0;
}
.tabs {
  padding-top: 32px;
  width: 400px;
  margin: auto;
}
.log-wrapper {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #494949;
  overflow: hidden;
  display: flex;
  align-items: center;
}
.logo-card {
  position: relative;
  width: 500px;
  height: 75vh;
  margin: auto;
  border-radius: 10px;
  background-color: #ffffff;
  box-shadow: 4px 4px 8px 0px #424242;
  box-sizing: border-box;
  padding: 56px 20px 72px 20px;
}
.logo-content {
  overflow-y: auto;
  padding-bottom: 2rem;
  height: auto
}
.logo {
  width:180px;
  margin: auto;
}
/* .el-tabs__item {
  width: 200px;
  font-size: 16px;
  color: #a0a0a0;
  transition: ease 0.4s all;
} */
.el-tabs__item.is-active {
  font-weight: bold;
  color: #494949;
}
.input-group {
  width: 400px;
  margin: auto;
  padding-top: 20px;
  padding-bottom: 20px;
  flex-direction: column;
  justify-content: flex-start;
  text-align: left;
}
.title {
  color: #a0a0a0;
  font-weight: 500;
  font-size: 14px;
  margin-bottom: 8px;
}
.buttons-set {
  position: absolute;
  left: 50px;
  right: 50px;
  bottom: 20px;
  background-color: #ffffff;
  padding-top: 20px;
  text-align: right;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.warning {
  color: #f56c6c;
  font-size: 10pt;
  margin-bottom: 1rem
}
.loader {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(256, 256, 256, 0.7);
  display: flex;
  align-items: center;
}
@media (max-width: 1366px) {
  .logo-card {
    position: relative;
    width: 500px;
    height: 75vh;
    margin: auto;
    border-radius: 10px;
    background-color: #ffffff;
    box-shadow: 4px 4px 8px 0px #424242;
    box-sizing: border-box;
    padding: 48px 20px 32px 20px;
  }
  .logo {
    width: 140px;
    margin: auto;
  }
  .logo-content {
    overflow-y: auto;
    padding-bottom: 2rem;
    height: 70%;
  }
  /* .el-tabs__nav {
    width: 50%;
  } */
  /* .el-tabs__item {
    width: 100%;
    font-size: 16px;
    color: #aaaaaa;
    transition: ease 0.4s all;
  }
  .el-tabs__nav-prev {
    display: none;
  }
  .el-tabs__nav-next {
    display: none;
  } */
}
@media (max-width: 767px) {
  .logo-card {
    position: relative;
    width: 86%;
    height: 80vh;
    margin: auto;
    border-radius: 10px;
    background-color: #ffffff;
    box-shadow: 4px 4px 8px 0px #424242;
    box-sizing: border-box;
    padding: 32px 12px 30px 12px;
  }
  .logo {
    width: 100px;
    margin: auto;
  }
  .logo-content {
    overflow-y: auto;
    padding-bottom: 2rem;
    height: 80%
  }
  /* .el-tabs__nav {
    width: 50%;
  } */
  /* .el-tabs__item {
    width: 100%;
    font-size: 16px;
    color: #aaaaaa;
    transition: ease 0.4s all;
  }
  .el-tabs__nav-prev {
    display: none;
  }
  .el-tabs__nav-next {
    display: none;
  } */
  .input-group {
    width: 100%;
    margin: auto;
    padding-top: 12px;
    flex-direction: column;
    justify-content: flex-start;
    text-align: left;
  }
  .tabs {
    padding-top: 16px;
    width: 100%;
    margin: auto;
  }
  .buttons-set {
    position: absolute;
    left: 12px;
    right: 12px;
    bottom: 20px;
    background-color: #ffffff;
    padding-top: 12px;
    text-align: right;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
}
</style>
